// extracted by mini-css-extract-plugin
export default {"thresholdTitle":"ThresholdConfig_thresholdTitle__ovxNU","thresholdIcon":"ThresholdConfig_thresholdIcon__d29aS","mb0":"ThresholdConfig_mb0__VbIK1"};